export const USER_OPEN_LINK = '/user_open_link/' as const
export const USER_PUBLIC_INFO = `${USER_OPEN_LINK}info` as const
